const menuList = () => import('@/pages/permission/menu/index.vue');
const menuForm = () => import('@/pages/permission/menu/form.vue');

export default [{
    path: '/permission/menu/list',
    component: menuList,
    meta: [{
        name: '权限管理'
    },
    {
        name: '菜单列表',
        activeRoute: '/permission/menu/list'
    }]
}, {
    path: '/permission/menu/form',
    component: menuForm,
    meta: [{
        name: '权限管理'
    },
    {
        name: '菜单列表',
        url: '/permission/menu/list',
    },
    {
        name: '添加/编辑',
        activeRoute: '/permission/menu/list'
    }]
}];